export const simulationParam = {
    GRID_SIZE: 128,
    DIFFUSION_RATE: 0.5,
    COOLING_RATE: 0.05,
    GRID_LENGTH: 2.0,
    DELTA: 0.00001,
    INTERVAL: 50,
    SOURCE_WEIGHT: 1.0,
    SOURCE_AMPLIFY: 1.15,
    SOURCE_EDGE_EXT: 1.1,
    SOURCE_RADIUS: 0.05,
};